"use client";

import { cn } from "@/lib/utils";
import { useEffect, useRef } from "react";

interface VideoBackgroundProps {
  videoUrl: string;
  className?: string;
  loop?: boolean;
}

export function VideoBackground({
  videoUrl,
  className,
  loop = true,
}: VideoBackgroundProps) {
  const videoRef = useRef<HTMLVideoElement>(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: videoUrl is needed to trigger effect when video changes
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    video.load();
    video.play().catch(() => {});
  }, [videoUrl]);

  return (
    <div
      className={cn(
        "fixed inset-0 z-0 pointer-events-none overflow-hidden",
        className,
      )}
    >
      <video
        ref={videoRef}
        className="absolute inset-0 h-full w-full object-cover"
        src={videoUrl}
        muted
        loop={loop}
        playsInline
        preload="metadata"
      />
      <div className="absolute inset-0 bg-black/30" />
    </div>
  );
}
